<template>
  <div class="robot-card" @click="onClick">
    <div class="card-img"><img  :src="data.avatar" alt="" class="avatar-robot" :style="`width:${width}`"></div>
    <div class="card-content">
      <div class="title">{{data.title}}</div>
      <div class="desc">{{data.summary}}</div>
      <div class="btn">
        <span>详情了解</span>
        <img src="@/assets/images/robot/right-icon.png" alt="">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'robot-card',
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          id: '',
          avatar: '',
          title: '',
          subtitle: ''
        };
      }
    },
    topicType:{
      type: String,
    },
    width:{
      type: String,
    }
  },
  methods: {
    onClick(){
      this.$emit('onClick', this.data.id);
    }
  }
}
</script>
<style lang="less" scoped>
.robot-card{
  padding: 57px 48px;
  border-bottom:  1px solid #f0f0f0;
  display: flex;
   .robot-card:nth-of-type(7)
{
  border-bottom:  none !important;

}
  .card-img{
    /*flex: 1;*/

    .avatar-robot {
      // width: 206px;
      // height: 206px;
    }
  }
  .card-content {
    margin-left: 32px;
    position: relative;
      flex: 1;
    .title{
      font-size: 28px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
      color: #424242;
      line-height: 40px;
      margin-bottom: 16px; 
    }
    .desc {
      font-size: 22px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      color: #666666;
      line-height: 36px;
    }
    .btn{
      font-size: 20px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
      color: #d8609e;
      line-height: 26px;
      position: absolute;
      bottom: 0;
      display: flex;
      align-items: center;
      img {
        width: 24px;
        height: 24px;
        margin-left: 8px; 
      }
    }
  }
}
</style>